<template>
  <div class="product-search-page">
    <h2>Product Search</h2>
    <hr>
    <div class="subheader-wrapper">
      <h4>Products</h4>
    </div>
    <hr>
    <BasicDataGrid 
      :key="productTableKey"
      :dataSource="products"
      :dataGridKey="dataGridKey" 
      gridRef="productSearchGrid"
      :columns="columns"
      :actions="permissableActions"
      :showColumnLines="true"
      @editProduct="editProduct"
      :multiSelect="false"
      noDataText="No products could be found"
      />
    <Modal ref="editProductModal" >
      <EditProductForm v-model="editedProduct" @closeProductEdit="closeProductEdit" />
    </Modal>
  </div>
</template>
<script>
import BasicDataGrid    from '@/components/BasicDataGrid.vue';
import EditProductForm  from '@/components/EditProductForm.vue';

import { can }          from '@/permissions.js'

import {ProductService}   from '@/services';

// import { getDataSource }    from "../../../modules/helpers.js";
// let products = getDataSource('Products')



export default {
  name: 'ProductSearch',
  components: {
    BasicDataGrid,
    EditProductForm
  },
  data() {
    return {
      dataGridKey: 'Id',
      productTableKey: 0,
      loading: false,
      editedProduct: {},
      actions:[{
        hint: 'Edit',
        icon: 'edit',
        emit: 'editProduct',
      }],
      products: [],
      columns: [
        {text: 'ID', width: '60px', value: 'Id', dataType: "number"}, 
        {text: 'MFID', width: '75px', value:'MfgCode', dataType: "string"}, 
        {text: 'Part #', width: '75px', value:'PartNumber', dataType: "string"}, 
        {text: 'RefCode', width: '75px', value:'ReferenceCode', dataType: "string"}, 
        {text: 'Stock Code', width: '100px', value:'StockCode', dataType: "string"}, 
        {text: 'Description', value:'Description', dataType: "string", width: '100%'}, 
        {text: 'Retail', width: '100px', maxWidth: '150px', value:'Retail', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Dealer Cost', width: '100px', maxWidth: '150px', value:'DealerCost', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Customer Cost', width: '100px', maxWidth: '150px', value:'CustomerCost', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        }, 
        {text: 'Min', width: '100px', maxWidth: '150px', value:'MinimumPrice', dataType: "string",
          customizeText: (cellInfo) => {
            
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        },  
        {text: 'Max', width: '100px', maxWidth: '150px', value:'MaximumPrice', dataType: "string",
          customizeText: (cellInfo) => {
            return cellInfo.value? "$" + cellInfo.value.toFixed(2) : '$0.00';
          }
        },
      ],
    };
  },
  methods: {
    closeProductEdit(){
      this.productTableKey++;
      // const store = this.products.store()
      // console.log('data', store )
      // // let index = this.products.map(product => {return product.id}).indexOf(this.editedProduct.Id)
      // // this.products[index] = this.editedProduct;
      this.toggleEditProductModal()
      this.editedProduct = {}
    },
    toggleEditProductModal(){
      this.$refs.editProductModal.toggle(); 
    },
    editProduct(event){
      this.editedProduct = event.row.data
      
      this.toggleEditProductModal()
    },
    
    getProducts(){
      this.products = ProductService.getDataSource(this.dataGridKey);
    }
  },
  computed: {
    permissableActions() {
      return can('edit-products') ? this.actions : [];
    }
  },
  created(){
    this.getProducts();
  }
};
</script>
<style lang="scss" scoped>
  .product-search-page {
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    
  }
</style>
